/**
 * The studio: where the host checks the camera, the microphone and the light at the door, goes live with a 3, 2, 1,
 * and then sits in the same room the guests see, with the host's extras. This is the route and its data; the room
 * itself is `HostLive`. It sits outside the app's shell, so the room is full screen.
 */
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import type { LiveStudio } from "../../shared/types";
import { api } from "../lib/api";
import { HostLive } from "../public/live/HostLive";
import "../styles/guest.css";

export function LiveStudioView() {
  const { id = "" } = useParams();
  const [info, setInfo] = useState<LiveStudio | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    setInfo(null);
    setError("");
    api.studio
      .get(id)
      .then((studio) => alive && setInfo(studio))
      .catch((err: unknown) => alive && setError(err instanceof Error ? err.message : "The studio did not open."));
    return () => {
      alive = false;
    };
  }, [id]);

  if (info) return <HostLive info={info} />;
  return (
    <div className="gst">
      <p className="hk-wait" role="status">
        {error || "Opening the studio…"}
      </p>
    </div>
  );
}
